import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex whitespace-nowrap items-center gap-2" }
const _hoisted_2 = { class: "capitalize" }
const _hoisted_3 = {
  key: 0,
  class: "ml-2 text-xs max-w-full flex whitespace-nowrap overflow-hidden items-center text-inbox-gray-theme-600 border px-2 border-solid border-gray-300 rounded-md gap-2 py-0.5"
}

import { FaxShortMessage } from '@/inbox/composition';
import { SvgIcon } from '@/ui-kit';
import FileIcon from './FileIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FaxShortMessage',
  props: {
    message: null,
    isUnread: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	message: FaxShortMessage;
	isUnread: boolean;
};



// console.log(props.message);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["whitespace-nowrap overflow-hidden overflow-ellipsis", 
				__props.isUnread
					? 'text-inbox-gray-theme-600 font-medium'
					: 'text-inbox-gray-theme-600 font-light'
			])
    }, [
      (
					__props.message.content?.direction ===
					'outbound'
				)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Outbound ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Inbound")
          ], 64)),
      _createTextVNode(" Fax "),
      _createElementVNode("span", {
        class: _normalizeClass(["ml-2", 
					__props.isUnread
						? 'font-light text-inbox-gray-theme-400'
						: 'text-inbox-gray-theme-400  font-light'
				])
      }, [
        _createTextVNode(" Status: "),
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.message.content.status), 1)
      ], 2)
    ], 2),
    (__props.message.media?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(SvgIcon), {
            name: "file",
            class: "h-4 w-4 opacity-75"
          }),
          _createTextVNode(" " + _toDisplayString(__props.message.media[0].file_name), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})